/**
 * LaunchDarkly feature flag keys used across the application.
 *
 * Naming convention: ehr-screener-<feature-area>-<description>
 * All keys must match the corresponding flag key in the LaunchDarkly dashboard.
 */
export const FeatureFlags = {
    /** Controls visibility of the "Refer to sleep specialist" option in Clinical Options. */
    REFER_TO_SLEEP_SPECIALIST: 'ehr-screener-sleep-specialist-referral'
};
/**
 * Environment-specific default flag values.
 * Used as fallback when LaunchDarkly is disabled or during SDK initialization.
 *
 * Priority: LaunchDarkly remote value > environment override > core default (false)
 */
import coreFlags from '../../feature-flags/feature-flags-core.json';
import devDitFlags from '../../feature-flags/feature-flags-dev-dit.json';
import e2eFlags from '../../feature-flags/feature-flags-e2e.json';
import prodFlags from '../../feature-flags/feature-flags-prod.json';
const envFlagMap = {
    'dev-dit': devDitFlags['feature-flags'],
    e2e: e2eFlags['feature-flags'],
    prod: prodFlags['feature-flags']
};
/**
 * Resolves the environment tier from the ENV_NAME value.
 * Examples:
 *   "dev-dit-amr" → "dev-dit"
 *   "dev-fit-amr" → "dev-dit"
 *   "prod-e2e-intg-amr" → "e2e"
 *   "prod-amr" → "prod"
 */
function resolveEnvTier(envName) {
    if (!envName)
        return 'dev-dit';
    if (envName.includes('e2e'))
        return 'e2e';
    if (envName.startsWith('dev'))
        return 'dev-dit';
    return 'prod';
}
/**
 * Returns merged flag defaults for the current environment.
 * Core defaults are overridden by environment-specific values.
 */
export function getFeatureFlagDefaults() {
    var _a, _b;
    const envName = typeof window !== 'undefined' ? (_a = window.__ENV) === null || _a === void 0 ? void 0 : _a.ENV_NAME : undefined;
    const tier = resolveEnvTier(envName);
    const core = coreFlags['feature-flags'];
    const envOverrides = (_b = envFlagMap[tier]) !== null && _b !== void 0 ? _b : {};
    return Object.assign(Object.assign({}, core), envOverrides);
}
